<template>
	<div class="page-container">
		<md-dialog-alert
	      :md-active.sync="alert"
	      :md-content="msg"
	      md-confirm-text="Ok" />
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="backHome()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Pagamento via QRCode
				</span>
			</md-app-toolbar>
			<md-app-content style="padding: 5px;padding-top: 0px;">
				<md-empty-state style="color: white;" class="no-event-found"
				md-icon="sentiment_very_dissatisfied" v-if="qrNotFound"
				:md-label="msg">
				<md-button class="md-raised md-accent" v-on:click="backHome()">
					VOLTAR
				</md-button>
				</md-empty-state>
				<div class="md-layout md-gutter md-alignment-center-center" v-if="loadingCob">
					<img class="titan-logo" src="../assets/loading.gif" style="width: 90px;">
				</div>
				<div v-if="!loadingCob && !qrNotFound" class="fundo-ticket-number zig-zag-top zig-zag-bottom">
					<div class="md-layout">
						<div class="md-layout-item logo">
							<img class="titan-logo" src="../assets/titan_logo.png">
						</div>
					</div>
					<div class="md-layout" v-if="!completeInfo">
						<div class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px;">
							<div class="md-layout fundo-ticket-number-even" style="border: 1px solid black; padding: 0; ">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;border-right: 1px solid black;">
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Pré-Aposta:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ payment.bet_id }}</div>
										</td>
										<td>
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Data:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 17px;">{{ payment.bet_date }}</div>
										</td>
									</tr>
								</table>
							</div>
							<div class="md-layout fundo-ticket-number-odd" style="border: 1px solid black; padding: 0; border-top: unset;">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;border-right: 1px solid black;">
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Nome:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ payment.debtor_name }}</div>
										</td>
										<td>
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Valor:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 17px;">{{ payment.value }}</div>
										</td>
									</tr>
								</table>
							</div>
							<div class="md-layout fundo-ticket-number-odd" style="border: 1px solid black; padding: 0; border-top: unset;">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;border-right: 1px solid black;">
											<div class="md-layout-item md-size-100" style="text-align: center;font-size: 17px; cursor: pointer;" @click="copyURL(payment.qrcode_text)">Copiar código</div>
										</td>
									</tr>
								</table>
							</div>
							<qrcode-vue :value="payment.qrcode_text" :size="size" level="H" style="text-align: center; margin-top: 10px; margin-bottom: 10px;"></qrcode-vue>
							<div class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px;">
								<md-button class="md-raised md-primary" style="width: 95%;" @click="verificarPagamento()">JA PAGOU? CLIQUE AQUI PARA VERIFICAR!</md-button>
							</div>
						</div>
					</div>
					<div class="md-layout" v-if="completeInfo">
						<span style="text-align: center;margin-top: 10px;font-weight: bold;">PARA OBTER O QRCODE DE PAGAMENTO VIA PIX É NECESSÁRIO PREENCHER NOME E TELEFONE.</span>
						<div class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px;">
							<md-field>
						      <label>Apostador</label>
						      <md-input v-model="bet_punter"></md-input>
						    </md-field>
						    <span style="text-align: center;margin-top: 10px;font-weight: bold;">ATENÇÃO! É O NÚMERO DE TELEFONE QUE GARANTE O RECEBIMENTO EM CASO DE PRÊMIO, PORTANTO ATENTE-SE PARA DIGITA-LO CORRETAMENTE.</span>
						    <md-field>
						      <label>Telefone (apenas números)</label>
						      <md-input v-model="bet_punter_phone" type="phone"></md-input>
						    </md-field>
						    <md-button class="md-raised md-primary" style="width: 95%;" @click="concluir()">CONCLUIR</md-button>
						</div>
					</div>
					<div class="md-layout" v-if="completeInfo" style="margin-top: 10px;font-weight: bold;">
						<div class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px; text-align: justify;">
							EM CASO DE PRÊMIO, UTILIZE O NÚMERO INFORMADO NO CAMPO ACIMA E ENTRE EM CONTATO COM NOSSO WHATSAPP <span @click="solicitar()" style="font-size: 130%; color: black;">{{ suportePIX() }}</span>, ENVIE O NÚMERO DO SEU BILHETE E SOLICITE O SAQUE DO SEU PRÊMIO.
						</div>
					</div>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'
	import QrcodeVue from 'qrcode.vue';

	export default {
		name: 'TitanTicket',
		components: {
			QrcodeVue
		},
		props: ['ticket'],
		data () {
			return {
				id: 0,
				loadingCob: true,
				qrNotFound: false,
				completeInfo: false,
				payment: [],
				size: 150,
				bet_punter: "",
				bet_punter_phone: "",
		        alert: false,
			    msg: ""
			}
		},
        created() {
            this.id = this.$route.params.id;
        },
        methods: {
        	suportePIX: function(){
        		return this.$root.$data.SUPORTE_PIX;
        	},
        	solicitar: function() {
        		window.open("https://wa.me/55" + this.$root.$data.SUPORTE_PIX.match(  /\d+/g ).join("") + "?text=Gostaria%20de%20solicitar%20o%20saque%20de%20um%20premio!");
        	},
        	backHome: function() {
        		this.$router.push({ name: 'TitanTicket', params: { id: this.id }})
        	},
        	verifyOddEven: function(key) {
				return {
					'fundo-ticket-number-odd': (key % 2 == 0),
					'fundo-ticket-number-even': (key % 2 != 0)
				}
			},
        	verifyColorStatus: function(status) {
				return {
					'status-pendente-text': (status == 'Pendente'),
					'status-win-text': (status == 'Ganhou'),
					'status-lose-text': (status == 'Perdeu'),
					'status-canceled-text': (status == 'Cancelado'),
					'status-closed-text': (status == 'Encerrado')
				}
			},
	        concluir() {

	        	if (this.bet_punter == undefined || this.bet_punter == "" || this.bet_punter_phone == undefined || this.bet_punter_phone == "") {
	        		this.msg = "Apostador e telefone são obrigatórios.";
	        		this.alert = true;
					return false;
				}

	        	var jsonBet = {};
				jsonBet.bet_id = this.id;
				jsonBet.bet_punter = this.bet_punter;
				jsonBet.bet_punter_phone = this.bet_punter_phone;

				var form = new FormData();
				form.append("data", JSON.stringify(jsonBet));

				var config = {
				  headers: {'Content-Type': 'application/x-www-form-urlencoded'}
				};

				var v = this;
				axios.post(this.$root.$data.API_URL + 'update-bet-info', form, config)
				.then(function (response) {
			        // console.log(response);
		        	let result = response.data
					if (result.success) {
						window.location.reload()
					}
					else {
						v.msg = result.message
						v.alert = true
					}
				});

	        },
	        verificarPagamento() {
				if (this.id == 0) return false;

				this.loadingCob = true;

	        	var config = {
				  headers: {}
				};

				axios
				.get(this.$root.$data.API_URL + 'confirm-pix-payment/' + this.id, config)
				.then(response => {
					if (response.data.success) {
		        		if (response.data.paid == true) this.$router.push({ name: 'TitanReprint', params: { id: this.id }})
		        		else {
		        			this.msg = 'Infelizmente seu pagamento ainda não foi confirmado, aguarde uns instantes e tente novamente.';
							this.alert = true
		        		}
		        	} else {
		        		this.msg = response.data.message + " Basta clicar no número a seguir <b><a href=\"https://wa.me/55" + this.$root.$data.SUPORTE_PIX.match(  /\d+/g ).join("") + "?text=Gostaria%20do%20reembolso%20da%20aposta%20"+ this.id + "%20pois%20o%20evento%20expirou!\">" + this.$root.$data.SUPORTE_PIX + "</a></b>."
						this.alert = true
		        	}
		        	this.loadingCob = false;
		        })
				.finally(() => this.loadingCob = false );
	        },
	        async copyURL(textToCopy) {
			    // navigator clipboard api needs a secure context (https)
			    if (navigator.clipboard && window.isSecureContext) {
			        // navigator clipboard api method'
			        await navigator.clipboard.writeText(textToCopy);

			        alert('Copiado!');
			    } else {
			        // text area method
			        let textArea = document.createElement("textarea");
			        textArea.value = textToCopy;
			        // make the textarea out of viewport
			        textArea.style.position = "fixed";
			        textArea.style.left = "-999999px";
			        textArea.style.top = "-999999px";
			        document.body.appendChild(textArea);
			        textArea.focus();
			        textArea.select();
			        return new Promise((res, rej) => {
			            // here the magic happens
			            document.execCommand('copy') ? res() : rej();
			            textArea.remove();

			            alert('Copiado!');
			        });
			    }
			}/*,
			async copyURL(text) {
			    try {
			      await navigator.clipboard.writeText(text);
			      alert('Copiado');
			    } catch($e) {
			      alert('Erro ao copiar código.');
			    }
			}*/
        },
        mounted() {

        	if (this.id == 0) return false;
        	if (!(this.$root.$data.PIX)) return false;

        	axios
			.get(this.$root.$data.API_URL + 'generate-pix-payment/' + this.id)
			.then(response => {
				if (response.data.success) {
	        		this.payment = response.data.payment
	        	} else {
	        		if (response.data.message == "complete_info") {
	        			this.id = response.data.bet_id
	        			this.bet_punter = response.data.bet_punter
	        			this.completeInfo = true
	        		}
	        		else {
	    				this.qrNotFound = true
	    				this.msg = response.data.message
	        		}
	        	}
	        })
			.finally(() => this.loadingCob = false );
        }
	}
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
	primary: #000000, // The primary color of your brand
	accent: #CB1323 // The secondary color of your brand
	));

@import "~vue-material/dist/theme/all"; // Apply the theme

.logo {
	text-align: center;
	margin-top: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/TitanPIXQRCode.vue